import React from 'react';
import { TERRAIN } from '../content';
import { SCENE_IMG } from '../media';

/* The illustration lives in a contained card so the section keeps the same
   outer rhythm as every other section on the page. The two colors below are
   sampled from the artwork so it extends seamlessly above and below; they are
   not brand colors and are used nowhere else. */
const SKY = '#C7EBF9';
const FOREGROUND = '#31594F';
export function Terrain() {
  return <section className="border-t border-border bg-card" aria-labelledby="terrain-heading" data-id="element-95" data-mp="370q5gzvxta8l">
      <div className="section-shell py-16 lg:py-20" data-id="element-96" data-mp="3bvvqlwhimkvm">
        <div className="overflow-hidden rounded-lg" data-id="element-97" data-mp="3gwjpf4bzk60e">
          <div className="px-6 pt-10 sm:px-10 lg:px-12 lg:pt-12" style={{
          backgroundColor: SKY
        }} data-id="element-98" data-mp="3guqevdy951n4">
            <p className="overline" style={{
            color: 'rgba(2,28,14,0.72)'
          }} data-id="element-99" data-mp="3lttl31pyxdwo">
              The terrain
            </p>
            <h2 id="terrain-heading" className="mt-5 max-w-2xl font-serif text-h3 text-foreground lg:text-h2" data-id="element-100" data-mp="1rhvfraus5262">
              The climb is hard. You shouldn&rsquo;t make it alone.
            </h2>
          </div>

          {/* The ridges are drawn ~30% flatter than the source, then trimmed so
              only open sky leaves the top and only flat foreground leaves the
              bottom. Both seams stay invisible at every width. */}
          <div aria-hidden="true" className="relative -my-px aspect-[100/28] overflow-hidden" data-id="element-101" data-mp="2sn2bxbs3qy57">
            <img src={SCENE_IMG.terrainIllustration} alt="" className="absolute left-0 top-[-15.7%] h-[140.7%] w-full" data-id="element-102" data-mp="3qat3ev4khzsb" />
          </div>

          <div className="text-cream" style={{
          backgroundColor: FOREGROUND
        }} data-id="element-103" data-mp="3gcwn7owrwenc">
            <ol className="grid gap-8 px-6 pb-10 pt-2 sm:grid-cols-2 sm:px-10 lg:grid-cols-4 lg:gap-10 lg:px-12 lg:pb-12" data-id="element-104" data-mp="3cccqgmg43d1q">
              {TERRAIN.map((item, i) => <li key={item.title} className="border-t border-[rgba(252,250,244,0.3)] pt-5" data-id="element-105" data-mp="20xfu0rhlllkc" data-mpi={i}>
                  <span className="text-body-sm text-[var(--brand-gold-lifted)]" data-id="element-106" data-mp="22elckggka07r">0{i + 1}</span>
                  <h3 className="mt-3 font-serif text-h4 leading-snug" data-id="element-107" data-mp="27er7q6m1i4ul">{item.title}</h3>
                  <p className="mt-2 text-body-sm leading-body text-[rgba(252,250,244,0.85)]" data-id="element-108" data-mp="1sh7699ocqrt6">
                    {item.body}
                  </p>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}